// // import React
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useFormData } from '../../ContextData/ContextData';
// import Footer from '../../../../../components/Footer/Footer';
// import InnerNav from '../../../../../components/InnerNav/InnerNav';
// import './Chalit.scss';

// const Chalit = () => {
//   const {userData} = useFormData();
//   const [chalitData, setChalitData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchChalitData = async () => {
//       try {
//         const response = await axios.get(
//           'https://core-c343.onrender.com/api/chalit-table',
//           {
//             params: {
//               year: userData.year,
//               month: userData.month,
//               day: userData.day,
//               hour: userData.hour,
//               minute: userData.minute ,
//               location: userData.city,
//               timezone: 'Asia/Kolkata',
//             },
//           }
//         );

//         // API returns: response.data.chalitTable.chalitTable
//         setChalitData(response.data.chalitTable.chalitTable);
//       } catch (error) {
//         console.error('Error fetching Chalit data:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchChalitData();
//   }, []);

//   return (
//     <div className="chalit-container">
//       <InnerNav />
//       <h2>Chalit Table & Chart</h2>

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <table className="chalit-table">
//           <thead>
//             <tr>
//               <th>Bhav</th>
//               <th>Rashi</th>
//               <th>Bhav Begin</th>
//               <th>Next Rashi</th>
//               <th>Mid Bhav</th>
//             </tr>
//           </thead>
//           <tbody>
//             {chalitData.map((row, index) => (
//               <tr key={index}>
//                 <td>{row.Bhav}</td>
//                 <td>{row.Rashi}</td>
//                 <td>{row.BhavBegin}</td>
//                 <td>{row.NextRashi}</td>
//                 <td>{row.MidBhav}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}

//       <Footer />
//     </div>
//   );
// };

// export default Chalit;




// Chalit.jsx
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useFormData } from "../../ContextData/ContextData";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import "./Chalit.scss";

const Chalit = () => {
  const { userData } = useFormData();
  const [chalitData, setChalitData] = useState([]);
  const [loading, setLoading] = useState(true);

  // For chart
  const canvasRef = useRef(null);
  const [houses, setHouses] = useState({});
  const [ascSign, setAscSign] = useState(null);

  // Fixed house slots for North Indian Chart
  const houseSlots = {
    1: [ [10, 50], [30, 80], [30, 110] ],     // Top-left slot
    2: [ [110, 220], [160, 200], [110, 240] ],// Bottom-left slot
    3: [ [340, 300], [310, 300], [340, 280] ],// Bottom slot
    4: [ [320, 90], [330, 110], [350,140],[370,120]],             // Top-right slot
    5: [ [190, 230], [190, 250] ],            // Middle bottom slot
    6: [ [290, 360], [290, 320], [290, 340] ],// Bottom-right slot
    7: [ [20, 290], [60, 300] ],              // Left-middle slot
    8: [ [90, 330], [110, 330],[50, 330] ],             // Left-bottom slot
    9: [ [240, 200], [210, 210], [180, 220] ],// Middle-right slot
    10:[ [290, 50], [290, 70] ],              // Right-top slot
    11:[ [200, 90], [200, 120], [180, 170] ], // Middle-top slot
    12:[ [80, 50], [80, 30], [80, 80] ]       // Left-top slot
  };

  // Fetch Chalit + Chart Data
  useEffect(() => {
    const fetchChalitData = async () => {
      try {
        const response = await axios.get(
          "https://core-c343.onrender.com/api/chalit-table",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              location: userData.city,
              timezone: "Asia/Kolkata",
            },
          }
        );

        const data = response.data.chalitTable;
        setChalitData(data.chalitTable); // table rows
        setHouses(data.houses || {}); // for chart

        // Ascendant sign calc
        const ascDegree = parseFloat(data.ascendant);
        const signNum = Math.floor(ascDegree / 30) + 1;
        setAscSign(signNum);
      } catch (error) {
        console.error("Error fetching Chalit data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChalitData();
  }, []);

  // Rotate houses based on Ascendant
  const getRotatedHouseNumber = (slot) => {
    if (!ascSign) return slot;
    return ((ascSign - 1 + slot - 1) % 12) + 1;
  };

  // Draw Chart
  useEffect(() => {
    if (!canvasRef.current || Object.keys(houses).length === 0 || !ascSign) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Outer diamond
    ctx.beginPath();
    ctx.moveTo(200, 0);
    ctx.lineTo(400, 200);
    ctx.lineTo(200, 400);
    ctx.lineTo(0, 200);
    ctx.closePath();
    ctx.strokeStyle = "#FF8C42";
    ctx.lineWidth = 2;
    ctx.stroke();

    // Cross lines
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(400, 400);
    ctx.moveTo(400, 0);
    ctx.lineTo(0, 400);
    ctx.stroke();

    // Houses + Planets
    Object.keys(houseSlots).forEach((slot) => {
      const realHouseNum = getRotatedHouseNumber(parseInt(slot));
      const items = houses[realHouseNum] || [];
      const positions = houseSlots[slot];

      // Draw each planet/house item
      items.forEach((item, idx) => {
        const pos = positions[idx] || positions[0];
        if (!pos) return;

        ctx.fillStyle = item.color || "black";
        ctx.font = "bold 14px Arial";
        ctx.fillText(`${item.name}(${realHouseNum})`, pos[0], pos[1]);
      });
    });
  }, [houses, ascSign]);

  // Download Chart
  const downloadImage = () => {
    const canvas = canvasRef.current;
    const link = document.createElement("a");
    link.download = "kundali.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  // Copy Chart
  const copyImage = () => {
    const canvas = canvasRef.current;
    canvas.toBlob((blob) => {
      const item = new ClipboardItem({ "image/png": blob });
      navigator.clipboard.write([item]);
    });
  };

  return (
    <div className="chalit-container">
      <InnerNav />
      <h2>Chalit Table & Kundali Chart</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          

          {/* Chalit Table */}
          <table className="chalit-table">
            <thead>
              <tr>
                <th>Bhav</th>
                <th>Rashi</th>
                <th>Bhav Begin</th>
                <th>Next Rashi</th>
                <th>Mid Bhav</th>
              </tr>
            </thead>
            <tbody>
              {chalitData.map((row, index) => (
                <tr key={index}>
                  <td>{row.Bhav}</td>
                  <td>{row.Rashi}</td>
                  <td>{row.BhavBegin}</td>
                  <td>{row.NextRashi}</td>
                  <td>{row.MidBhav}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Kundali Chart */}
          <h2 className="chart-text">Chalit Chart</h2>
          <div className="kundali-chart-container" style={{ textAlign: "center", marginBottom: "20px" }}>
            
            <canvas
              ref={canvasRef}
              width={400}
              height={400}
              style={{ border: "1px solid black" }}
            />
            {/* <div className="button-group" style={{ marginTop: "10px" }}>
              <button onClick={downloadImage}>Download PNG</button>
              <button onClick={copyImage} style={{ marginLeft: "10px" }}>
                Copy Image
              </button>
            </div> */}
          </div>
        </>
      )}

      <Footer />
    </div>
  );
};

export default Chalit;
